export function chatSurfaceUrl(chatId: number, region: string, offerId?: string, staffView = false): string {
  const query = new URLSearchParams()
  if (offerId) query.set('chatId', String(chatId))
  if (staffView) query.set('staffView', '1')
  const path = offerId ? `/offer/${encodeURIComponent(offerId)}` : `/trip-planner/chat-trip-planner/${chatId}`
  return `/${region.toLowerCase()}${path}${query.toString() ? `?${query}` : ''}`
}
